// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"#492172","accent":"#BFD730","accentDarker":"#a8bd2a","row":"_2kSY","pricingTable":"_3AMw","inner":"_2KG9","recommended":"_2UkX","buttonChoose":"_2_xJ","cis":"lYR6","name":"_1SuB","price":"_3nh1","descriptions":"_10Ah","button":"_3xJF","buttonCall":"_2zTe","features":"_33wF","feature":"_3YnS"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/PricingTable/PricingTable.scss
// module id = q89L
// module chunks = 0